import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { TooltipList } from 'packages/ui/Graph'

interface ConsumptionTooltipProps {
  active?: boolean
  payload?: Array<{ dataKey: string; value: number; payload: { date: string; value: number } }>
  scale?: 'day' | 'month'
}

const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 octet'
  const k = 1024
  const sizes = ['octets', 'Ko', 'Mo', 'Go', 'To']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const value = Math.round((bytes / Math.pow(k, i)) * 100) / 100
  return `${value} ${sizes[i]}`
}

const ConsumptionTooltip: React.FC<ConsumptionTooltipProps> = ({ active, payload, scale }) => {
  const { t, i18n } = useTranslation()

  if (!active || !payload?.[0]) return null

  const { date } = payload[0].payload
  const value = payload[0].value || 0

  const formattedDate = scale === 'month'
    ? moment(date, 'MM/YYYY').locale(i18n.language).format('MMMM YYYY')
    : moment(date, 'DD/MM').locale(i18n.language).format('dddd DD MMM YYYY')

  return (
    <TooltipList
      title={formattedDate}
      list={[
        {
          color: '#FDAE61',
          label: t('event_ssids.stats.consumption_title'),
          value: formatBytes(value)
        }
      ]}
    />
  )
}

export default ConsumptionTooltip